import React, { useState, useEffect } from "react";
import { Formik, Form } from 'formik';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Grid } from '@material-ui/core';
import * as Yup from 'yup';

// const currentYear = new Date().getFullYear();
// 
const CreateSalesTargetvsActual = (props) => {
    const [SalesExecutiveID, setSalesExecutiveID] = useState('');
    const [CmbFinancialAccYear, setCmbFinancialAccYear] = useState([]);
    //const [ComboMonth, setComboMonth] = useState([]);
    const [ComboSalesExecutive, setComboSalesExecutive] = useState([]);
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [responseGetData, fetchDataGetData] = UseFetchData();
    const [responseYearData, fetchYearTargetData] = UseFetchData();
    const [response, fetchData] = UseFetchData();
    const [FinancialYearID, setFinancialYearID] = useState('');
    const [Year1, setYear1] = useState('');
    const [Year2, setYear2] = useState('');
    const [April, setApril] = useState('0');
    const [May, setMay] = useState('0');
    const [June, setJune] = useState('0');
    const [July, setJuly] = useState('0');
    const [August, setAugust] = useState('0');
    const [September, setSeptember] = useState('0');
    const [October, setOctober] = useState('0');
    const [November, setNovember] = useState('0');
    const [December, setDecember] = useState('0');
    const [January, setJanuary] = useState('0');
    const [February, setFebruary] = useState('0');
    const [March, setMarch] = useState('0');
    const [FormError, setFormError] = useState('');
    const [financialYear, setFinancialYear] = useState("");


    const validationSchema = Yup.object({
        SalesExecutive: Yup.string().required('Required!'),
        // FinancialYear: Yup.string().required('Required!')
    });

    useEffect(() => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const nextYear = currentYear - 1;
        const financialYear = `${nextYear}-${currentYear}`;
        //setFinancialYear(financialYear);
    }, []);

    const onSubmit = values => {
        // debugger;
        if (values.April === "0" && values.May === "0" && values.June === "0" && values.July === "0" && values.August === "0" && values.September === "0" && values.October === "0" && values.November === "0" && values.December === "0" && values.January === "0" && values.February === "0" && values.March === "0") {

            setFormError("Any one Month Required!");
        }
        else {
            // debugger;
            setFormError('');
            //const Month = ["April","May","June","July","August","September","October","November","December","January","February","March"];
            const TargetInLakhs = [];
            TargetInLakhs.push(values.April);
            TargetInLakhs.push(values.May);
            TargetInLakhs.push(values.June);
            TargetInLakhs.push(values.July);
            TargetInLakhs.push(values.August);
            TargetInLakhs.push(values.September);
            TargetInLakhs.push(values.October);
            TargetInLakhs.push(values.November);
            TargetInLakhs.push(values.December);
            TargetInLakhs.push(values.January);
            TargetInLakhs.push(values.February);
            TargetInLakhs.push(values.March);
            var CreatedByID = sessionStorage.UID;
            var bodyFormData = new FormData();
            // debugger;
            bodyFormData.append("Mode", props.Mode);
            bodyFormData.append("SalesTargetID", props.SalesTargetID);
            bodyFormData.append("SalesExecutiveID", values.SalesExecutive);
            bodyFormData.append("FinancialYearID", values.FinancialYear);
            // bodyFormData.append("FinancialYearID", values.FinancialYear);
            bodyFormData.append("Year1", values.Year1);
            bodyFormData.append("Year2", values.Year2);
            // for (var i = 0; i < Month.length; i++) {
            //     bodyFormData.append('MonthYear[]', Month[i]);
            // }
            //appending the values in the array in cs file
            for (var j = 0; j < TargetInLakhs.length; j++) {
                bodyFormData.append('TargetInLakhs[]', TargetInLakhs[j]);
            }
            bodyFormData.append("CreatedByID", CreatedByID);
            fetchData("SalesTargetvsActual/Save", bodyFormData);
        }
    }

    useEffect(() => {
        if (response.Response === true) {
            alert("Data Saved Successfully");
            props.PopulateData();
            props.setOpen(false);
        }
        else if (response.Response === false) {
            if (response.Message.includes('Already') === true) {
                alert(response.Message);
                props.setOpen(false);
            }
            else {
                alert("Failed.");
            }
        }
    }, [response]);

    const SalesExecutiveData = (options) => {
        if (options !== undefined) {
            let SalesExecutive = options.map((data) =>
                <option
                    key={data.title}
                    value={data.id}
                >
                    {data.title}
                </option>
            );
            setComboSalesExecutive(SalesExecutive)
        }
    }

    // const FinancialYearOption = [
    //     { key: "2021 - 2022", value: "2021 - 2022" },
    //     { key: "2022 - 2023", value: "2022 - 2023" },
    // ];

    // const FinancialYearData = () => {
    //     let FinancialYear = FinancialYearOption.map((data) =>
    //         <option
    //             key={data.key}
    //             value={data.value}
    //         >
    //             {data.key}
    //         </option>
    //     );
    //     setComboFinancialYear(FinancialYear)
    // }
    const FinancialYearData = (options) => {
//        debugger;
        if (options !== undefined) {
            const AccYear = options.map((data) =>
                <option
                    key={data.title}
                    value={data.id}
                >
                    {data.title}
                </option>
            );
            setCmbFinancialAccYear(AccYear);
        }
    }

    const cleardata = () => {
        setApril('0');
        setMay('0');
        setJune('0');
        setJuly('0');
        setAugust('0');
        setSeptember('0');
        setOctober('0');
        setNovember('0');
        setDecember('0');
        setJanuary('0');
        setFebruary('0');
        setMarch('0');


    }

    useEffect(() => {
        // debugger;
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse["AccountYear"] !== undefined
                // && ComboDataResponse["Month"] !== undefined
                && ComboDataResponse["SalesExecutive"] !== undefined) {
                FinancialYearData(ComboDataResponse["AccountYear"]);
                // setComboMonth(ComboDataResponse["Month"]);
                SalesExecutiveData(ComboDataResponse["SalesExecutive"]);
                if (props.SalesTargetID !== "" && props.Mode === "Update") {
                    GetByIDData();
                }
            }
        }

    }, [ComboDataResponse]);

    useEffect(() => {
        GetComboData();
        // debugger;

    }, [])
    const GetComboData = () => {
        fetchComboData("SalesTargetvsActual/ComboData");
    };

    const handleYear = (e) => {
        // debugger;
        setFinancialYearID(e.target.value);
        var bodyFormData = new FormData();
        //fetching the option value  like 2020-2021  and e.target.value is id,both option value and e.target,value are different
        const FinYear = e.target.selectedOptions[0].label;//ComboDataResponse["FinancialYear"].find(finyear => finyear=e.target.value).title;
        setYear1(FinYear.substring(0, 4));
        setYear2(FinYear.substring(5));
        console.log(Year1);
        bodyFormData.append("SalesExecutiveID", SalesExecutiveID);
        bodyFormData.append("AccYearID", e.target.value);
        fetchYearTargetData("SalesTargetvsActual/GetYearData", bodyFormData);// Get target data with corresponding year 
    }

    const handleExecutive = (e) => {
        // debugger;
        setSalesExecutiveID(e.target.value);
        var bodyFormData = new FormData();
        //fetching the option value  like 2020-2021  and e.target.value is id,both option value and e.target,value are different
        //const FinYear = e.target.selectedOptions[0].label;//ComboDataResponse["FinancialYear"].find(finyear => finyear=e.target.value).title;
        //setYear1(FinYear.substring(0, 4));
        //setYear2(FinYear.substring(5));
        bodyFormData.append("SalesExecutiveID", e.target.value);
        bodyFormData.append("AccYearID", FinancialYearID);
        // bodyFormData.append("AccYear", AccYear);
        fetchYearTargetData("SalesTargetvsActual/GetYearData", bodyFormData);// Get target data with corresponding year 
    }

    useEffect(() => {
        // debugger;//useeffect for fetch current year sales target data and set coor6esponding months
        if (responseYearData !== undefined && responseYearData.length > 0) {
            setSalesExecutiveID(responseYearData[0].SalesExecutiveID);
            setFinancialYearID(responseYearData[0].FinancialYearID);
            // const ResponseFinYear = ComboDataResponse["FinancialYear"].find(finyear => finyear = responseYearData[0].FinancialYearID).title;
            // setYear1(ResponseFinYear.substring(0, 4));
            // setYear2(ResponseFinYear.substring(5));

            for (let i = 0; i < responseYearData.length; i++) {
                if (responseYearData[i].MonthYear === "April") {
                    setApril(responseYearData[i].TargetInLakhs);
                }
                else if (responseYearData[i].MonthYear === "May") {
                    setMay(responseYearData[i].TargetInLakhs);
                }
                if (responseYearData[i].MonthYear === "June") {
                    setJune(responseYearData[i].TargetInLakhs);
                }
                else if (responseYearData[i].MonthYear === "July") {
                    setJuly(responseYearData[i].TargetInLakhs);
                }
                if (responseYearData[i].MonthYear === "August") {
                    setAugust(responseYearData[i].TargetInLakhs);
                }
                else if (responseYearData[i].MonthYear === "September") {
                    setSeptember(responseYearData[i].TargetInLakhs);
                }
                if (responseYearData[i].MonthYear === "October") {
                    setOctober(responseYearData[i].TargetInLakhs);
                }
                else if (responseYearData[i].MonthYear === "November") {
                    setNovember(responseYearData[i].TargetInLakhs);
                }
                if (responseYearData[i].MonthYear === "December") {
                    setDecember(responseYearData[i].TargetInLakhs);
                }
                else if (responseYearData[i].MonthYear === "January") {
                    setJanuary(responseYearData[i].TargetInLakhs);
                }
                if (responseYearData[i].MonthYear === "February") {
                    setFebruary(responseYearData[i].TargetInLakhs);
                }
                else if (responseYearData[i].MonthYear === "March") {
                    setMarch(responseYearData[i].TargetInLakhs);
                }
            }
        }
        else {
            cleardata();
        }
    }, [responseYearData]);

    const GetByIDData = () => {
        var bodyFormData = new FormData();
        // debugger;
        bodyFormData.append("SalesTargetID", props.SalesTargetID);
        fetchDataGetData("SalesTargetvsActual/GetByID", bodyFormData);
    }

    useEffect(() => {
        // debugger;
        if (responseGetData !== undefined && responseGetData.length > 0) {
            setSalesExecutiveID(responseGetData[0].SalesExecutiveID);
            setFinancialYearID(responseGetData[0].FinancialYearID);
            //for displaying the label according to the financial year drop down
            // const ResponseFinYear = ComboDataResponse["FinancialYear"].find(finyear => finyear = responseGetData[0].FinancialYearID).title;
            setYear1(responseGetData[0].AccYear.substring(0, 4));
            setYear2(responseGetData[0].AccYear.substring(5));

            for (let i = 0; i < responseGetData.length; i++) {
                // setApril(responseGetData[i].MonthYear === "April" ? responseGetData[i].TargetInLakhs : 0);
                // setMay(responseGetData[i].MonthYear === "May" ?  responseGetData[i].TargetInLakhs : 0);
                // setJune(responseGetData[i].MonthYear === "June" ?  responseGetData[i].TargetInLakhs : 0);
                // setJuly(responseGetData[i].MonthYear === "July" ?  responseGetData[i].TargetInLakhs : 0);
                // setAugust(responseGetData[i].MonthYear === "August" ?  responseGetData[i].TargetInLakhs : 0);
                // setSeptember(responseGetData[i].MonthYear === "September" ?  responseGetData[i].TargetInLakhs : 0);
                // setOctober(responseGetData[i].MonthYear === "October" ?  responseGetData[i].TargetInLakhs : 0);
                // setNovember(responseGetData[i].MonthYear === "November" ?  responseGetData[i].TargetInLakhs : 0);
                // setDecember(responseGetData[i].MonthYear === "December" ?  responseGetData[i].TargetInLakhs : 0);
                // setJanuary(responseGetData[i].MonthYear === "January" ?  responseGetData[i].TargetInLakhs : 0);
                // setFebruary(responseGetData[i].MonthYear === "February" ?  responseGetData[i].TargetInLakhs : 0);
                // setMarch(responseGetData[i].MonthYear === "March" ?  responseGetData[i].TargetInLakhs : 0);
                if (responseGetData[i].MonthYear === "April") {
                    setApril(responseGetData[i].TargetInLakhs);
                }
                else if (responseGetData[i].MonthYear === "May") {
                    setMay(responseGetData[i].TargetInLakhs);
                }
                if (responseGetData[i].MonthYear === "June") {
                    setJune(responseGetData[i].TargetInLakhs);
                }
                else if (responseGetData[i].MonthYear === "July") {
                    setJuly(responseGetData[i].TargetInLakhs);
                }
                if (responseGetData[i].MonthYear === "August") {
                    setAugust(responseGetData[i].TargetInLakhs);
                }
                else if (responseGetData[i].MonthYear === "September") {
                    setSeptember(responseGetData[i].TargetInLakhs);
                }
                if (responseGetData[i].MonthYear === "October") {
                    setOctober(responseGetData[i].TargetInLakhs);
                }
                else if (responseGetData[i].MonthYear === "November") {
                    setNovember(responseGetData[i].TargetInLakhs);
                }
                if (responseGetData[i].MonthYear === "December") {
                    setDecember(responseGetData[i].TargetInLakhs);
                }
                else if (responseGetData[i].MonthYear === "January") {
                    setJanuary(responseGetData[i].TargetInLakhs);
                }
                if (responseGetData[i].MonthYear === "February") {
                    setFebruary(responseGetData[i].TargetInLakhs);
                }
                else if (responseGetData[i].MonthYear === "March") {
                    setMarch(responseGetData[i].TargetInLakhs);
                }
            }

        }
    }, [responseGetData]);

    return (
        <div>
            <Formik initialValues={{
                SalesExecutive: SalesExecutiveID, FinancialYear: FinancialYearID, Year1: Year1, Year2: Year2, April: April, May: May,
                June: June, July: July, August: August, September: September, October: October, November: November, December: December, January: January, February: February, March: March,
            }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={1} container direction="row">
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"SalesExecutive"}
                                    style={{ display: "block", width: "100%" }}
                                >
                                    {"Sales Executive"}
                                </label>
                            </Grid>
                            <Grid item xs={9}>
                                <BiztranControlsFormik
                                    control="select"
                                    name='SalesExecutive'
                                    options={ComboSalesExecutive}
                                    onChange={handleExecutive}
                                //onChange={(e) => setSalesExecutiveID(e.target.value)}
                                //value = {SalesExecutiveID}
                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"FinancialYear"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Financial Year"}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="select"
                                    // control="input"
                                    name="FinancialYear"
                                    // value={financialYear}
                                    options={CmbFinancialAccYear}
                                    onChange={handleYear}
                                    value={FinancialYearID}
                                // onChange={e => {var Year = e.target.value}}
                                //onChange={(e) => setOpportunityDate(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6} style={{ fontWeight: 'bold' }}>
                                All Amounts in Lakhs
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"April"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"April "}{Year1}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="April"
                                    onChange={(e) => setApril(e.target.value)}
                                //value = {April}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"May"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"May "}{Year1}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="May"
                                    onChange={(e) => setMay(e.target.value)}
                                //value = {May}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"June"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"June "}{Year1}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="June"
                                    onChange={(e) => setJune(e.target.value)}
                                //value = {June}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"July"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"July "}{Year1}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="July"
                                    onChange={(e) => setJuly(e.target.value)}
                                // value = {July}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"August"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"August "}{Year1}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="August"
                                    onChange={(e) => setAugust(e.target.value)}
                                //value = {August}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"September"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"September "}{Year1}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="September"
                                    onChange={(e) => setSeptember(e.target.value)}
                                // value = {September}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"October"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"October "}{Year1}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="October"
                                    onChange={(e) => setOctober(e.target.value)}
                                //value = {October}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"November"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"November "}{Year1}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="November"
                                    onChange={(e) => setNovember(e.target.value)}
                                //value = {November}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"December"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"December "}{Year1}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="December"
                                    onChange={(e) => setDecember(e.target.value)}
                                //value = {December}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"January"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"January "}{Year2}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="January"
                                    onChange={(e) => setJanuary(e.target.value)}
                                // value = {January}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"February"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"February "}{Year2}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="February"
                                    onChange={(e) => setFebruary(e.target.value)}
                                //value = {February}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label
                                    htmlFor={"March"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"March "}{Year2}
                                </label>
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="number"
                                    name="March"
                                    onChange={(e) => setMarch(e.target.value)}
                                // value = {March}
                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={1} container direction="row">
                            <Grid item xs={12} style={{ fontWeight: 'bold', color: 'Red' }}>{FormError}</Grid>
                        </Grid>

                        <Grid spacing={1} container direction="row">
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
};

export default CreateSalesTargetvsActual;